import { useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';
import { ReplayDateSchema } from 'shared';

const REPLAY_PARAM = 'asOf';

/** Today as YYYY-MM-DD in UTC, the bound the API uses for replay dates. */
export function replayToday(): string {
  return new Date().toISOString().slice(0, 10);
}

/** The weekday before or after a YYYY-MM-DD date, skipping Saturday and Sunday. */
export function shiftWeekday(date: string, direction: 1 | -1): string {
  const day = new Date(`${date}T00:00:00.000Z`);
  do {
    day.setUTCDate(day.getUTCDate() + direction);
  } while (day.getUTCDay() === 0 || day.getUTCDay() === 6);
  return day.toISOString().slice(0, 10);
}

/** The Market Console replay date from the URL; undefined means live data. */
export function useReplayDate(): {
  asOf: string | undefined;
  setAsOf: (date: string | null) => void;
} {
  const [searchParams, setSearchParams] = useSearchParams();
  const parsed = ReplayDateSchema.safeParse(searchParams.get(REPLAY_PARAM));
  const setAsOf = useCallback(
    (date: string | null) => {
      setSearchParams(
        (current) => {
          const next = new URLSearchParams(current);
          if (date) next.set(REPLAY_PARAM, date);
          else next.delete(REPLAY_PARAM);
          return next;
        },
        { replace: true },
      );
    },
    [setSearchParams],
  );
  return { asOf: parsed.success ? parsed.data : undefined, setAsOf };
}
